import "../Profile_Intro/ProfileIntro.scss";
import secretary from '../../../assets/Images/President.jpeg'

const ProfileIntroSection = () => {
    return (
        <section className="profileIntroSection">
            <article className='profile-into-section'>
                <div style={{ display: "flex", flexDirection: "column", gap:"20px" }}>
                    <p>
                        NICAS, started in 2001 by the Noorul Islam Educational Trust, is affiliated to Manonmaniam Sundaranar University. With a meagre strength of just 75 students, offering three courses namely Computer Science, Information Technology and Computer Applications, the College progressed leaps and bounds by adding new courses and infrastructural facilities. The college has an effective student strength of about 1500 and offers 14 U.G. courses and 5 P.G. courses. There are 80 members of the Teaching staff and 32 members of the Administrative staff. Among the Teaching staff, there are 65 Ph.D holders and the rest of them are NET/SLET qualified.
                    </p>
                    <p>
                        The NAAC peer team visited the campus and the College was awarded ‘B’ Grade. Our college competed in NIRF(National Ranking Framework). Institution’s Innovation Council was established in the year 2020-2021. The college has the history of Silver Jubilee in its educational services.
                    </p>
                    </div>

                <div className='image-section-1'>
                    <img src={secretary} alt="Image Of Dr.A.P.Majeed khan" />
                    <div style={{ display: "flex", flexDirection: "column", gap: "7px" }}>
                        <h3 style={{ color: "#0D553A" }} className='secretary-name'>Janab Dr.A.P.Majeed khan </h3>
                        <h3 style={{ color: "gray" }} className="position">SECRETARY</h3>
                    </div>
                </div>
            </article>
        </section>
    )
}

export default ProfileIntroSection
